import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useRef, useState } from "react";
import { Modal, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';
import { ReactComponent as EditIcon } from '../../Assets/img/Edit-icon.svg';
import { ReactComponent as Error } from '../../Assets/img/Error.svg';
import { ReactComponent as ResetIcon } from '../../Assets/img/Reset-primary-icon.svg';
import PartnerService from "../../Services/PartnerService";

function EditPartner(props) {
    const [error, setError] = useState("");
    const [messagePopup, setMessagePopup] = useState(false);
    const [partner, setPartner] = useState({});

    const addressRef = useRef();
    const contactNumberRef = useRef();
    const stateRef = useRef();
    const localityRef = useRef();
    const organizationNameRef = useRef();
    const commonNameRef = useRef();

    useEffect(() => {
        PartnerService.GetPartner(props.countryId, props.partnerId).then((response) => {
            if (response.response == null) {
                setError(response.Errors[0].message);
            } else {
                setPartner(response.response);
            }
        }).catch((err) => {
            setError(err.data);
        });
    }, [])

    function updatePartner(event) {
        event.preventDefault();

        var updatePartnerDTO = {
            Address: addressRef.current.value ?? null,
            ContactNumber: contactNumberRef.current.value ?? null,
            State: stateRef.current.value ?? null,
            Locality: localityRef.current.value ?? null,
            OrganizationName: organizationNameRef.current.value ?? null,
            CommonName: commonNameRef.current.value ?? null,
        };

        PartnerService.updatePartnerDetails(props.countryId, props.partnerId, updatePartnerDTO)
            .then((response) => {
                if (response.response == null) {
                    setError(response.errors[0].message);
                    setMessagePopup(true);
                }
                else {
                    props.onClose();
                    props.onShowMessage("Partner updated sucessfully.");
                }
            })
            .catch((err) => {
                setError(err.response.data.errors[0].message);
                setMessagePopup(true);
            });
    }

    return (
        <Modal centered={true} show={true} onHide={props.onClose}>
            <ModalHeader className="AddDeviceHeader" style={{ border: "none" }} closeButton >
                <ModalTitle className="Header">
                    <strong>Edit Partner</strong>
                </ModalTitle>
            </ModalHeader>
            <Modal.Body style={{ padding: '0' }}>
                {messagePopup && (
                    <div className="alert alert-warning"><Error /><span className="message-popup-title">{error}</span></div>
                )}
                <form onSubmit={updatePartner}>
                    <div style={{ padding: '3%' }}>
                        <div>
                            <label for="address" className="label" >Address</label>
                            <div>
                                <input id="address" type="text" className="InputField" defaultValue={partner.address} placeholder="-Text-" min="0" maxlength="30" ref={addressRef} required />
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="contactnumber" className="label" >Contact Number</label>
                            <div>
                                <input id="contactnumber" type="tel" className="InputField" defaultValue={partner.contactNumber} placeholder="-Text-" min="0" maxlength="30" ref={contactNumberRef} required />
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="state" className="label" >State</label>
                            <div>
                                <input id="state" type="text" className="InputField" defaultValue={partner.state} placeholder="-Text-" min="0" maxlength="30" ref={stateRef} />
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="locality" className="label" >Locality</label>
                            <div>
                                <input id="locality" type="text" className="InputField" defaultValue={partner.locality} placeholder="-Text-" min="0" maxlength="30" ref={localityRef} />
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="organizationname" className="label" >Organization Name</label>
                            <div>
                                <input id="organizationname" type="text" className="InputField" defaultValue={partner.organizationName} placeholder="-Text-" min="0" maxlength="30" ref={organizationNameRef} required />
                            </div>
                        </div>
                        <br />
                        <div>
                            <label for="commonname" className="label" >Common Name</label>
                            <div>
                                <input id="commonname" type="text" className="InputField" defaultValue={partner.commonName} placeholder="-Text-" min="0" maxlength="30" ref={commonNameRef} required />
                            </div>
                        </div>
                    </div>
                    <ModalFooter className="AddDeviceFooter" style={{ border: "none" }}>
                        <div>
                            <button type="reset" className="secondary-button" onClick={() => { setError(""); setMessagePopup(false); }}>
                                <span className="secondary-button-icon"><ResetIcon /></span>
                                <span className="secondary-button-text">Reset</span>
                            </button>
                            &nbsp;
                            <button type="submit" className="primary-button">
                                <span className="primary-button-icon"><EditIcon /></span>
                                <span className="primary-button-text">Edit Partner</span>
                            </button>
                        </div>
                    </ModalFooter>
                </form>
            </Modal.Body>
        </Modal >
    );
}

export default EditPartner;